var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        backgroundColor: function (_a) {
            var isDragging = _a.isDragging, isSelectedForPlayer = _a.isSelectedForPlayer;
            if (isDragging) {
                return theme.palette.action.selected;
            }
            return isSelectedForPlayer
                ? theme.palette.action.hover
                : theme.palette.background.paper;
        },
    },
}); });
export var TrackTableRow = function (_a) {
    var _b, _c, _d;
    var children = _a.children, isSelectedForPlayer = _a.isSelectedForPlayer, dragHandle = _a.dragHandle, props = __rest(_a, ["children", "isSelectedForPlayer", "dragHandle"]);
    var classes = useStyles({
        isSelectedForPlayer: isSelectedForPlayer,
        isDragging: ((_b = props.snapshot) === null || _b === void 0 ? void 0 : _b.isDragging) || false,
    });
    var handler = dragHandle !== null && dragHandle !== void 0 ? dragHandle : {};
    return (React.createElement(TableRow, __assign({ classes: { root: classes.root } }, (_c = props.provided) === null || _c === void 0 ? void 0 : _c.draggableProps, handler, { innerRef: (_d = props.provided) === null || _d === void 0 ? void 0 : _d.innerRef }, props), children));
};
